import { OptionalFeature } from "../../../../base/domain/drawing";
import { ICopyLinkedCheckBehavior } from "./ICopyLinkedCheckBehavior";

export class CopyLinkedCheckBehavior extends OptionalFeature {
  constructor(
    isEnable: boolean     = false,
    public no: number = 1,
  ) {
    super(isEnable);
  }

  clone(): CopyLinkedCheckBehavior {
    return new CopyLinkedCheckBehavior(this.isEnable, this.no);
  }

  static from(source: ICopyLinkedCheckBehavior): CopyLinkedCheckBehavior {
    return new CopyLinkedCheckBehavior(source.isEnable, source.no);
  }

  static to(source: CopyLinkedCheckBehavior): ICopyLinkedCheckBehavior {
    return {
      isEnable: source.isEnable,
      no: source.no,
    };
  }
}
